export default "__VITE_ASSET__DVQy$_hv__"